import React from 'react';
import './pageSizeSelector.css';
import { PageSize } from '../../hooks/usePagination';

interface PageSizeSelectorProps {
	pageSize: PageSize
	onChange: (newPageSize: PageSize) => void
}

export default function PageSizeSelector({pageSize, onChange}: PageSizeSelectorProps) {
	return <div className="pageSizeSelector">
		<label htmlFor="pageSize" className="pageSizeSelectorLabel">Races per page:</label>
		<select 
			id="pageSize"
			className="pageSizeSelectorSelect"
			value={pageSize} 
			onChange={(e) => onChange(e.target.value as PageSize)}
		>
			<option value={10}>10</option>
			<option value={25}>25</option>
			<option value={50}>50</option>
			<option value={100}>100</option>
			<option value="all">All</option>
		</select>
	</div>
}

